let events;

if (typeof window.PointerEvent === "function") {
  events = {
    down: "touchstart pointerdown",
    move: "touchmove pointermove",
    up: "touchend touchcancel pointerup pointerleave pointercancel"
  };
} else if (typeof window.TouchEvent === "function") {
  events = {
    down: "touchstart",
    move: "touchmove",
    up: "touchend touchcancel"
  };
} else {
  events = {
    down: "mousedown",
    move: "mousemove",
    up: "mouseup mouseleave"
  };
}

export function onPointer(event, elem, handler, eventOpts) {
  events[event].split(" ").forEach(name => {
    elem.addEventListener(name, handler, eventOpts);
  });
}

export function destroyPointer(event, elem, handler) {
  events[event].split(" ").forEach(name => {
    elem.removeEventListener(name, handler);
  });
}

/**
 * Utilites for working with multiple pointer events
 */
function findEventIndex(pointers, event) {
  let i = pointers.length;
  while (i--) {
    if (pointers[i].pointerId === event.pointerId) {
      return i;
    }
  }
  return -1;
}
export function addPointer(pointers, event, isTouchMode) {
  // if (isTouchMode && event.pointerType == 'mouse') return;
  // if (!isTouchMode && event.pointerType == 'touch') return;

  // if touch mode, remove any mouse ponter events
  pointers.forEach((o, i) => {
    if (isTouchMode && o.type.indexOf("pointer") > -1) {
      pointers.splice(i, 1);
    }
  });

  let i;
  // Add touches if applicable
  if (event.touches) {
    i = 0;
    for (const touch of event.touches) {
      touch.pointerId = i++;
      touch.type = "touch";
      addPointer(pointers, touch);
    }
    return;
  }
  i = findEventIndex(pointers, event);
  // Update if already present
  if (i > -1) {
    // alert('FOUND')
    pointers.splice(i, 1);
  }
  pointers.push(event);
}
export function removePointer(pointers, event) {
  // Add touches if applicable
  if (event.touches) {
    // Remove all touches
    while (pointers.length) {
      pointers.pop();
    }
    return;
  }
  const i = findEventIndex(pointers, event);
  if (i > -1) {
    pointers.splice(i, 1);
  }
}
/**
 * Calculates a center point between
 * the given pointer events, for panning
 * with multiple pointers.
 */
export function getMiddle(a, b) {
  if (!b) return a;
  return {
    clientX: (a.clientX + b.clientX) / 2,
    clientY: (a.clientY + b.clientY) / 2
  };
}
/**
 * Calculates the distance between two points
 * for pinch zooming.
 * Limits to the first 2
 */
export function getDistance(pointers) {
  if (pointers.length < 2) {
    return 0;
  }
  const event1 = pointers[0];
  const event2 = pointers[1];
  return Math.sqrt(Math.pow(Math.abs(event2.clientX - event1.clientX), 2) + Math.pow(Math.abs(event2.clientY - event1.clientY), 2));
}

export function constrainScale(toScale, minScale, maxScale) {
  return Math.min(Math.max(toScale, minScale), maxScale);
}

export function getDimensions(elem) {
  const parent = elem.parentElement;
  const style = window.getComputedStyle(elem);
  const parentStyle = window.getComputedStyle(parent);
  const rectElem = elem.getBoundingClientRect();
  const rectParent = parent.getBoundingClientRect();
  return {
    elem: {
      style,
      width: rectElem.width,
      height: rectElem.height,
      top: rectElem.top,
      bottom: rectElem.bottom,
      left: rectElem.left,
      right: rectElem.right
    },
    parent: {
      style: parentStyle,
      width: rectParent.width,
      height: rectParent.height,
      top: rectParent.top,
      bottom: rectParent.bottom,
      left: rectParent.left,
      right: rectParent.right
    }
  };
}

export function createTextSelectionInterceptor() {
  var dragObject;
  var prevSelectStart;
  var prevDragStart;

  return {
    capture: capture,
    release: release
  };

  function capture(domObject) {
    prevSelectStart = window.document.onselectstart;
    prevDragStart = window.document.ondragstart;

    window.document.onselectstart = disabled;

    dragObject = domObject;
    dragObject.ondragstart = disabled;
  }

  function release() {
    window.document.onselectstart = prevSelectStart;
    if (dragObject) dragObject.ondragstart = prevDragStart;
  }
}

export function disabled(e) {
  e.stopPropagation();
  return false;
}
